import { ILogManager } from '../../interface/log.manager.interface';

export class LogManager implements ILogManager {
  private debugLog: boolean;
  constructor(deps: { debug: boolean }) {
    this.debugLog = deps.debug;
  }
  debug(message: string, ...args: any[]): void {
    if (this.debugLog) {
      console.debug(message, args);
    }
  }
  info(message: string, ...args: any[]): void {
    if (this.debugLog) {
      console.info(message, args);
    }
  }
  error(message: string, ...args: any[]): void {
    console.error(`P8_CUBE_HELPER_ERROR - ${message}`, args);
  }
}
